import React, { useState } from 'react'
import { CBadge, CSmartTable } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilGift } from '@coreui/icons'
import { toast } from 'react-toastify'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import GamePrizeService from 'src/service/GamePrizeService'
import Notify from '../Notify'

const API_URL = process.env.REACT_APP_API_URL

const columns = [
  { key: 'title', label: 'Prize', filter: false, sorter: true },
  { key: 'prize_type', label: 'Type', filter: false, sorter: true },
  { key: 'is_active', label: 'Status', filter: false, sorter: false, _style: { width: '16%' } },
  { key: 'actions', label: 'Actions', filter: false, sorter: false, _style: { width: '1%' } },
]

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  onEditPrize,
}) => {
  const [actionLoading, setActionLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [tableId, setTableId] = useState(null)

  const deletePrize = (id) => {
    setActionLoading(true)
    GamePrizeService.deletePrize({ id })
      .then((res) => {
        if (res.status === 200) {
          toast.dismiss()
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleFeaturedUnfeatured = (id, status) => {
    setActionLoading(true)
    GamePrizeService.updateFeatured(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleStatus = (id, status) => {
    setActionLoading(true)
    GamePrizeService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleCancel = () => setShowConfirm(false)
  const handleConfirm = () => {
    deletePrize(tableId)
    setShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)

  return (
    <div className="ge-datatable ge-datatable--no-select">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        sorterValue={columnSorter}
        noItemsLabel="No prizes yet"
        scopedColumns={{
          title: (item) => (
            <td>
              <div className="gp-prize-cell">
                {item.image ? (
                  <img
                    className="gp-prize-thumb"
                    src={`${API_URL}uploads/gameprize/${item.image}`}
                    alt={item.title}
                    onError={(e) => {
                      e.target.style.display = 'none'
                    }}
                  />
                ) : (
                  <span className="gp-prize-thumb gp-prize-thumb--empty">
                    <CIcon icon={cilGift} size="sm" />
                  </span>
                )}
                <span
                  className="fw-semibold text-primary"
                  role="button"
                  onClick={() => onEditPrize(item.id)}
                >
                  {item.title}
                </span>
              </div>
            </td>
          ),
          prize_type: (item) => <td>{item.prize_type || '-'}</td>,
          is_active: (item) => (
            <td>
              <div className="d-flex flex-wrap gap-1">
                <CBadge
                  color={item.is_active === 1 ? 'success' : 'warning'}
                  shape="rounded-pill"
                  className="px-2 py-1"
                >
                  {item.is_active === 1 ? 'Activated' : 'Deactivated'}
                </CBadge>
                {item.is_featured === 1 && (
                  <CBadge color="info" shape="rounded-pill" className="px-2 py-1">
                    Featured
                  </CBadge>
                )}
              </div>
            </td>
          ),
          actions: (item) => (
            <td>
              <RowActionsMenu
                actions={[
                  { label: 'Edit', onClick: () => onEditPrize(item.id) },
                  item.is_active === 1
                    ? {
                        label: 'Deactivate',
                        disabled: actionLoading,
                        onClick: () => handleStatus(item.id, 0),
                      }
                    : {
                        label: 'Activate',
                        disabled: actionLoading,
                        onClick: () => handleStatus(item.id, 1),
                      },
                  item.is_featured === 1
                    ? {
                        label: 'Remove Featured',
                        disabled: actionLoading,
                        onClick: () => handleFeaturedUnfeatured(item.id, 0),
                      }
                    : {
                        label: 'Mark Featured',
                        disabled: actionLoading,
                        onClick: () => handleFeaturedUnfeatured(item.id, 1),
                      },
                  { label: 'Delete', danger: true, onClick: () => areYouSureModal(item.id) },
                ]}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading || actionLoading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: totalPages || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        showConfirm={showConfirm}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        text="Are you sure you want to delete this prize?"
      />
    </div>
  )
}

export default Table
